import { defineWave } from '../schema';

/** BOSS — L'ARRIVÉE DU HÉRAUT.
 *
 *  ── Les cinq premières secondes ──
 *  Un seul spawn dans tout le fichier, et il est à 5,0 s. Ces cinq secondes de
 *  vide ne sont pas un délai technique : c'est LE SILENCE QUI FAIT EXISTER LE
 *  BOSS (PLAN.md §6.6, fourchette 4 à 6 s).
 *
 *  Un boss annoncé par un fondu musical au milieu d'une vague de popcorn n'est
 *  qu'un ennemi de plus avec beaucoup de points de vie. Un boss annoncé par le
 *  silence est un événement — parce que le joueur, qui vient de passer deux
 *  minutes à ne jamais pouvoir arrêter de tirer, entend d'un coup qu'il n'y a
 *  plus rien à viser. L'inquiétude fait le travail que la mise en scène ne peut
 *  pas faire.
 *
 *  ⚠️ « Calme ABSOLU » se vérifie au niveau, pas ici. Ce fichier garantit
 *  qu'aucun ennemi n'APPARAÎT pendant cinq secondes ; il ne garantit pas que
 *  l'écran soit vide. C'est au bloc précédent de monde-1-3.def.ts d'avoir cessé
 *  de produire assez tôt pour que les traînards soient morts ou sortis (voir la
 *  note d'intégration). Deux Faucheurs oubliés en vol suffiraient à annuler tout
 *  l'effet.
 *
 *  ── Couloir 3 ──
 *  Le centre, et c'est obligatoire à double titre. Le registre refuse tout
 *  ennemi de plus de 200 PV dans les couloirs de bord 0 et 6 (piège de bord,
 *  PLAN.md §6.11) — 18 000 PV n'y auraient jamais eu leur place. Et le boss doit
 *  descendre dans l'axe : sa poursuite latérale ne veut rien dire tant que le
 *  joueur ne l'a pas d'abord vu au repos, au milieu.
 *
 *  ── Durée ──
 *  96 s, très au-delà des 40 à 55 s de combat attendus. La marge est
 *  volontaire : `levelSystem` ne sait pas qu'un boss est mort, il ne connaît
 *  que des horloges. Une durée trop courte ne raccourcirait pas le combat, elle
 *  ferait démarrer le bloc suivant PAR-DESSUS — soit la fin du monde 1 pendant
 *  qu'on affronte encore son boss. */
export default defineWave({
  id: 'boss-heraut',
  duration: 96,
  spawns: [{ at: 5.0, enemy: 'heraut', lane: 3, count: 1, spacing: 0 }],
});
